import React from 'react';
import PropTypes from 'prop-types';
import { reducer } from './reducer';
import { BeaconInput } from './BeaconInput';

const defaultImpressionBeacons = creative => {
  const impressionBeacons = ((creative && creative.beacons) || []).filter(
    beacon => beacon.event === 'impression'
  );

  return impressionBeacons.length === 0
    ? [{ event: 'impression', url: '' }]
    : impressionBeacons;
};

export const ImpressionBeaconList = ({
  creative,
  CreativeService,
  beaconRequired
}) => {
  const [beacons, dispatch] = React.useReducer(
    reducer,
    defaultImpressionBeacons(creative)
  );

  React.useEffect(
    function overwriteImpressionBeacons() {
      const previousBeacons = creative.beacons || [];
      CreativeService.set('beacons', [
        ...previousBeacons.filter(({ event }) => event !== 'impression'),
        ...beacons
      ]);
    },
    [beacons]
  );

  React.useEffect(
    function updateRequiredFlags() {
      dispatch({ type: 'setRequired', payload: { required: beaconRequired } });
    },
    [beaconRequired]
  );

  const handleImpressionUrlChange = (index, url) => {
    dispatch({ type: 'updateBeacon', index, payload: { url } });
  };

  const handleVendorChange = (index, vendorId) => {
    dispatch({ type: 'assignVendor', index, vendorId });
  };

  return beacons.map((beacon, index, impBeacons) => {
    const button =
      index === impBeacons.length - 1 ? (
        <button
          className="btn btn-default"
          type="button"
          onClick={() => dispatch({ type: 'addBeacon', event: 'impression' })}
        >
          + New Tag
        </button>
      ) : (
        <button
          className="btn btn-default"
          type="button"
          onClick={() => dispatch({ type: 'removeBeacon', index })}
        >
          Remove
        </button>
      );

    return (
      <BeaconInput
        key={`impression-beacon-${index}`}
        nameAttr={`impression_beacon_${index}`}
        value={beacon.url}
        applyGdprValidations={!!creative.runningInEu}
        labelContent="Impression Tracker (1x1)"
        onInputChange={event =>
          handleImpressionUrlChange(index, event.target.value)
        }
        onVendorChange={vendorId => handleVendorChange(index, vendorId)}
        button={button}
      />
    );
  });
};

ImpressionBeaconList.propTypes = {
  creative: PropTypes.shape({
    runningInEu: PropTypes.bool,
    action: PropTypes.string,
    beacons: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        event: PropTypes.string
      })
    )
  }).isRequired,
  CreativeService: PropTypes.shape({
    set: PropTypes.func.isRequired
  }).isRequired,
  beaconRequired: PropTypes.bool.isRequired
};
